/**
 * Global price-list tabs: switch visible list without Ajax.
 */
(function () {
	function getTabs(root) {
		return Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
	}

	function activate(root, tab) {
		if (!root || !tab) {
			return;
		}

		var targetId = tab.getAttribute('aria-controls');
		var tabs = getTabs(root);
		var panels = root.querySelectorAll('[role="tabpanel"]');

		tabs.forEach(function (item) {
			var selected = item === tab;
			item.classList.toggle('is-active', selected);
			item.setAttribute('aria-selected', selected ? 'true' : 'false');
		});

		panels.forEach(function (panel) {
			var show = panel.id === targetId;
			panel.hidden = !show;
			panel.classList.toggle('is-active', show);

			if (show) {
				panel.setAttribute('aria-labelledby', tab.id);
			} else {
				panel.removeAttribute('aria-labelledby');
			}
		});
	}

	document.addEventListener('click', function (e) {
		var tab = e.target.closest('[data-price-charts-tabs] [role="tab"]');
		if (!tab) {
			return;
		}

		var root = tab.closest('[data-price-charts-tabs]');
		if (!root) {
			return;
		}

		e.preventDefault();
		activate(root, tab);
	});

	document.addEventListener('keydown', function (e) {
		var tab = e.target.closest('[data-price-charts-tabs] [role="tab"]');
		if (!tab) {
			return;
		}

		if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== 'Home' && e.key !== 'End') {
			return;
		}

		var root = tab.closest('[data-price-charts-tabs]');
		if (!root) {
			return;
		}

		var tabs = getTabs(root);
		var index = tabs.indexOf(tab);
		if (index < 0) {
			return;
		}

		var next = index;
		if (e.key === 'ArrowRight') {
			next = (index + 1) % tabs.length;
		} else if (e.key === 'ArrowLeft') {
			next = (index - 1 + tabs.length) % tabs.length;
		} else if (e.key === 'Home') {
			next = 0;
		} else if (e.key === 'End') {
			next = tabs.length - 1;
		}

		e.preventDefault();
		activate(root, tabs[next]);
		tabs[next].focus();
	});
})();
